import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "select"]
  static classes = ["hidden"]

  connect() {
    this.toggle()
  }

  toggle() {
    const allInputs = this.inputTargets
    const selectedInputs = this.inputTargets.filter(input => input.dataset.toggleInputOnSelectInputValue === this.selectTarget.value)

    allInputs.forEach(input => {
      input.disabled = true
      input.classList.add(this.hiddenClass)
    })

    selectedInputs.forEach(input => {
      input.disabled = false
      input.classList.remove(this.hiddenClass)
    })
  }
}
